import gql from "graphql-tag";
import type { LangCode } from "../../../../_common/types.js";
import { EngagementInfo, FeedConnection } from "../_common.js";
import { App } from "../app-config.js";
import { IImagePreview } from "../gallery.js";
import { Topic } from "../topics.js";
import { image } from "../fragments.js";
import { Quiz } from "./quiz.js";

export interface GetGameVariables {
    langCode?: LangCode;
    id: string;
}

export interface GetGameData<G extends Game> {
    game: G | null;
}

export type GameTypename = "Quiz" | "OutcomeQuiz";

export interface Game<C = GameContent> {
    __typename: GameTypename;
    id: string;
    slug: string | null;
    date: string;
    updatedAt: string;
    featured: boolean;
    topics: (Topic | null)[];
    contentLangs: LangCode[];
    content: C;
    promoApps: (App | null)[];
    engagementInfo: EngagementInfo;
    usersCount: number | null;
    recommendedGames: GameForCard[];
}

export interface GameContent {
    title: string;
    metaTitle: string;
    text: string;
    metaDescription: string;
    keywords: string | null;
    image: IImagePreview | null;
    startButton: string;
}

export type GameForCard = Pick<
    Game,
    "__typename" | "id" | "date" | "featured" | "usersCount" | "content"
> &
    Pick<Quiz, "avgScore" | "questionsNumber">;

export interface GetGamesFeedVariables {
    langCode?: LangCode;
    first?: number;
    after?: string;
}

export interface GetGamesFeedData {
    games: FeedConnection<GameForCard> | null;
}

export const GET_GAMES_FEED = gql`
    query getGamesFeed($langCode: LangCode, $first: Int, $after: GameCursor) {
        games: games(first: $first, after: $after) {
            totalCount
            offset
            edges {
                cursor
                node {
                    __typename
                    id
                    date
                    featured
                    usersCount
                    ... on Quiz {
                        questionsNumber
                        avgScore
                    }
                    content(langCode: $langCode) {
                        title
                        metaTitle
                        text
                        metaDescription
                        startButton
                        image {
                            ...image
                        }
                    }
                }
            }
        }
    }
    ${image}
`;

export interface PickGameQuestionVariantVariables {
    input: {
        quizId: string; // TODO: check & replace with id?
        variantId: string;
    };
}

export interface SaveGameResultVariables {
    input: {
        quizId: string; // TODO: check & replace with id?
        result: number;
    };
}
